import { takeLatest, call, put } from "redux-saga/effects";
import {
  cityUpdated,
  CITY_UPDATE_REQUEST,
  cityUpdateError,
} from "../../actions/cities";
import updateCity from "../../../../../backend/oncall/partners/cities/update";

const requestUpdate = function*(action) {
  try {
    yield call(
      updateCity,
      action.payload.cityId,
      action.payload.formData.name,
      action.payload.formData.state,
      parseInt(action.payload.formData.regionId, 10),
      action.payload.formData.enabled,
    );
    yield put(cityUpdated());
  } catch (error) {
    yield put(cityUpdateError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(CITY_UPDATE_REQUEST, requestUpdate);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/cities/request-update.js